import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_1: FaireProductEntity = {
  token: "toysmith-1",
  type: "product",
  name: "Egg Bouncers, Spring, Easter",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/d70dd2bc3d53727fdd084c2d50d59a04a0a5821034f8cbf99f4eb84b634bb9a5.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 8.5,
  msrpDollars: 17,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
